export const formValuesToAPI = (props, formValues) => {
  const profileInfo = props.profile.profile;
  return {
    password: formValues.newPassword,
    repeatNewPass: formValues.confirmNewPassword,
    id: profileInfo.id,
    email: profileInfo.email
  };
};
